import request from '@/utils/request_api';
import requests from '@/utils/request_yin';

const domain = process.env.api;
const domains = process.env.yins;
//快递费价格计算
export function GetKdf_v2(kdgs, iWeight, sheng, shi) {
	// console.log(kdgs, iWeight, sheng, shi)
	let kdf = 0
	if (sheng) {
		if (kdgs === '平安达' || kdgs === '联昊通') {
			if (sheng.indexOf('广东') >= 0) {
				kdf = 0
			} else {
				kdf = 99999
			}
		} else
			if (kdgs === '顺丰') {
				let feiyong = [
					{ a: '广东', b: 18, c: 1 },
					{ a: '福建', b: 34, c: 1.4 },
					{ a: '海南', b: 41, c: 1.4 },
					{ a: '安徽', b: 42, c: 1.8 },
					{ a: '江西', b: 43, c: 1.4 },
					{ a: '贵州', b: 43, c: 1.7 },
					{ a: '河南', b: 43, c: 1.8 },
					{ a: '陕西', b: 43, c: 1.8 },
					{ a: '湖南,广西', b: 44, c: 1.6 },
					{ a: '上海,浙江,江苏,云南', b: 44, c: 1.7 },
					{ a: '重庆', b: 44, c: 1.8 },
					{ a: '山东', b: 44, c: 2 },
					{ a: '山西', b: 44, c: 2.2 },
					{ a: '湖北', b: 45, c: 1.6 },
					{ a: '四川', b: 45, c: 2 },
					{ a: '河北', b: 45, c: 2.2 },
					{ a: '天津', b: 47, c: 1.8 },
					{ a: '北京', b: 49, c: 2.1 },
					{ a: '辽宁', b: 54, c: 2.1 },
					{ a: '内蒙', b: 60, c: 2 },
					{ a: '宁夏', b: 57, c: 2 },
					{ a: '甘肃', b: 58, c: 2 },
					{ a: '青海', b: 58, c: 2.3 },
					{ a: '吉林', b: 62, c: 1.8 },
					{ a: '黑龙江', b: 66, c: 2 },
					{ a: '新疆', b: 119, c: 1.8 },
				]
				for (let i in feiyong) {
					let xingsheng = feiyong[i].a.split(',')
					for (let j in xingsheng) {
						if (sheng.indexOf(xingsheng[j]) >= 0) {
							if (iWeight <= 20) {
								kdf = feiyong[i].b
							} else {
								kdf = feiyong[i].b + (Math.ceil(iWeight) - 20) * feiyong[i].c
							}
						}
					}
				}
			} else
				if (kdgs === '优速') {
					let feiyong = [
						{ a: '江苏,浙江,上海', b: 5, c: 1.3 },
						{ a: '湖南,湖北,安徽,福建,江西', b: 5, c: 1.8 },
						{ a: '天津,北京,海南,河北,河南,四川,重庆,广西,山东', b: 5, c: 2 },
						{ a: '山西,陕西,云南,贵州', b: 5, c: 3.5 },
						{ a: '宁夏,甘肃,青海', b: 5, c: 3.5 },
						{ a: '辽宁,黑龙江,吉林,内蒙古', b: 5, c: 3.5 },
						{ a: '香港', b: 15, c: 5 },
						{ a: '新疆', b: 10, c: 8 },
						{ a: '台湾,西藏', b: 15, c: 10 },
						{ a: '广东', b: 0, c: 0 },
					]
					for (let i in feiyong) {
						let xingsheng = feiyong[i].a.split(',')
						for (let j in xingsheng) {
							if (sheng.indexOf(xingsheng[j]) >= 0) {
								if (iWeight <= 1) {
									kdf = feiyong[i].b
								} else {
									kdf = feiyong[i].b + (Math.ceil(iWeight) - 1) * feiyong[i].c
								}
							}
						}
					}
				} else if (kdgs == '中通快递' || kdgs == '韵达快递' || kdgs == '申通快递') {
					let feiyong = [
						{ a: '江苏,浙江,上海,湖南,湖北,安徽,福建,江西,广西', b: 5, c: 1.2, d: 0.9, e: 0.7 },
						{ a: '天津,河北,河南,四川,重庆,山东,山西,陕西,云南,贵州', b: 5, c: 1.7, d: 1.5, e: 1.2 },
						{ a: '北京,海南', b: 5, c: 2, d: 1.8, e: 1.6 },
						{ a: '辽宁,黑龙江,吉林', b: 5, c: 2.4, d: 2.1, e: 1.8 },
						{ a: '宁夏,甘肃,青海', b: 5, c: 2.7, d: 2.3, e: 2 },
						{ a: '内蒙古', b: 5, c: 3, d: 2.7, e: 2.4 },
						{ a: '新疆', b: 20, c: 11.4, d: 7, e: 4.4 },
						{ a: '西藏', b: 20, c: 11.4, d: 7, e: 5.4 },
						{ a: '广东', b: 0, c: 0,d:0,e:0 },
					]
					for (let i in feiyong) {
						let xingsheng = feiyong[i].a.split(',')
						for (let j in xingsheng) {
							if (sheng.indexOf(xingsheng[j]) >= 0) {
								if (iWeight <= 1) {
									kdf = feiyong[i].b
								} else if(iWeight>1 && iWeight<=30){
									kdf = feiyong[i].b + (Math.ceil(iWeight) - 1) * feiyong[i].c
								}else if(iWeight>30 && iWeight<=70){
                                    kdf = feiyong[i].b + (Math.ceil(iWeight) - 1) * feiyong[i].d
								}else if(iWeight>70){
                                    kdf = feiyong[i].b + (Math.ceil(iWeight) - 1) * feiyong[i].e
								}
							}
						}
					}
				} else if (kdgs == '安能物流(包送货上门)') {
					let feiyong = [
						{ a: '江苏,浙江,上海,湖南,安徽,福建,江西,广西', b: 30, c: 1.5 },
						{ a: '湖北', b: 36, c: 1.8 },
						{ a: '天津,北京,海南,河北,河南,山东', b: 36, c: 1.9 },
						{ a: '四川,重庆,山西,陕西,云南,贵州', b: 40, c: 2 },
						{ a: '宁夏,甘肃,内蒙古', b: 52, c: 2.6 },
						{ a: '辽宁,黑龙江,吉林', b: 48, c: 2.4 },
						{ a: '青海', b: 60, c: 3 },
						{ a: '新疆,西藏', b: 160, c: 8 },
						{ a: '广东', b: 0, c: 0 },
					]
					for (let i in feiyong) {
						let xingsheng = feiyong[i].a.split(',')
						for (let j in xingsheng) {
							if (sheng.indexOf(xingsheng[j]) >= 0) {
								if (iWeight <= 20) {
									kdf = feiyong[i].b
								} else {
									kdf = feiyong[i].b + (Math.ceil(iWeight) - 20) * feiyong[i].c
								}
							}
						}
					}
				}
	}
	// console.log('重量，快递费',kdf,iWeight)
	return (kdf)
}
// 订单列表查询
export function req_orderList(uid, page, pageSize, flag, displayStartDate, displayEndDate, query) {
	const data = {
		method: 'POST',
		data: {
			uid: uid,			//用户id
			page: page,			//页数
			pageSize: pageSize,	//条数
			flag: flag,			//订单状态
			displayStartDate: displayStartDate,	//开始查询时间
			displayEndDate: displayEndDate,		//结束查询时间
			query: query,						//查询条件(订单号/文件名/项目名)
		}
	}
	return request(domain + '/order/orderList', data);
}

// bjlog表信息
export function req_bjlogInfo(bid) {
	const data = {
		method: 'POST',
		data: {
			bid: bid
		}
	}
	return request(domain + '/order/getbjlogbyid', data);
}

// 生成订单
export function req_orderCreate(uid, bid, filename, filepath, oilcompany, company, attn, tel, address, info, price, shippingmethods, paytype, filesize, oname, kdprice) {
	console.info('address1:' + address);
	// oname = oname.replace("自定义展开尺寸", "展开");
	// oname = oname.replace("使用定制刀模", "新版");
	// oname = oname.replace("使用标准刀模", "标版");
	// oname = oname.replace("定制刀模", "新版");
	// oname = oname.replace("标准刀模", "标版");
	// oname = oname.replace("单面哑膜", "单面哑膜");
	// oname = oname.replace("单面亮膜", "单面光膜");
	// oname = oname.replace("模切", "啤");
	// oname = oname.replace("切成品", "切");
	// oname = oname.replace("带自粘(打口水胶)", "打口水胶");
	const data = {
		method: 'POST',
		data: {
			uid: uid,//用户id
			bid: bid,//报单ID
			filename: filename,//文件名
			filepath: filepath,//文件存储路径
			oilcompany: oilcompany,//用户公司名称
			company: company,//收货单位
			attn: attn,//联系人
			tel: tel,//联系电话
			address: address,//地址
			info: info,//备注
			price: price,//总价
			shippingmethods: shippingmethods,//物流方式
			paytype: paytype,//支付方式
			filesize: filesize,//文件大小
			oname: oname,//前端自定义文件名
			kdprice: kdprice //快递费
		}
	}
	return request(domain + '/order/addorder', data);
}


// 获取订单详情
export function req_orderDetail(orderId) {
	const data = {
		method: 'POST',
		data: {
			orderId: orderId,
		}
	}
	return request(domain + '/order/orderDetail', data);
}

// 获取订单详情
export function req_orderView(id) {
	const data = {
		method: 'POST',
		data: {
			id: id,
		}
	}
	return request(domain + '/order/getorderview', data);
}

// 导出
export function req_orderExport(uid, page, pageSize, flag, displayStartDate, displayEndDate, query) {
	const data = {
		method: 'POST',
		data: {
			uid: uid,			//用户id
			page: page,			//页数
			pageSize: pageSize,	//条数
			flag: flag,			//订单状态
			displayStartDate: displayStartDate,	//开始查询时间
			displayEndDate: displayEndDate,		//结束查询时间
			query: query,						//查询条件(订单号/文件名/项目名)
		}
	}
	return request(domain + '/order/orderExport', data);
}

// 取消订单
export function req_orderCancel(id) {
	const data = {
		method: 'POST',
		data: {
			id: id,
		}
	}
	return requests(domains + '/caihang/CancelOrder', data);
}

// 更改支付方式为预存款支付
export function req_orderChangePayMethod(id) {
	const data = {
		method: 'POST',
		data: {
			id: id,
		}
	}
	return requests(domains + '/caihang/ChangePayMethod', data);
}
export function req_SaveCustomer(uid, RangeSetting, ProductSetting) {
	const data = {
		method: 'POST',
		data: {
			uid: uid,
			RangeSetting: RangeSetting,
			ProductSetting: ProductSetting,
		}
	}
	return requests(domains + '/caihang/SaveCustomerProfit', data);
}




// WEBPACK FOOTER //
// ./src/services/order.js